var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var latestHpiActions = (function() {
    var _requestLatestHpi = function() {
        return {
            type: constants.REQUEST_LATEST_HPI
        };
    }

    var _receiveLatestHpi = function(data) {
        return {
            type: constants.RECEIVE_LATEST_HPI,
            data: data.hpi
        };
    }

    var _fetchLatestHpi = function(submissionType, accessToken) {
        return function(dispatch) {
            dispatch(_requestLatestHpi(submissionType));
            api.get('/proxy/v1/hpis/latest?submissionType=' + (submissionType || 'GIHistory'), accessToken)
                .then(function(res) {
                    res.hpi.submissionType = submissionType;
                    dispatch(_receiveLatestHpi(res));
                })
                .catch(function(error) {
                    if(error.response){
                        if(error.response.data.message === 'Submission not found for user'
                            || String(error.response.data.message).startsWith('User has no hpi for the latest ')){

                            dispatch(_receiveLatestHpi({hpi: {}}));
                        }else{
                            dispatch(commonActions.setGenericResponseError('', error.response));
                        }
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    var _shouldFetchLatestHpi = function(submissionType, state) {
        var latestHpi = state.dashboard.latestHpi;
        if (Object.keys(latestHpi).length) {
            return false;
        } else {
            return true;
        }
    }

    var _fetchLatestHpiIfNeeded = function(submissionType, accessToken) {
        return function(dispatch, getState) {
            if (_shouldFetchLatestHpi(submissionType, getState())) {
                return dispatch(_fetchLatestHpi(submissionType, accessToken))
            }
        }
    }

    var _sendHpi2DoctorBegin = function(){
        return {
            type: constants.SEND_HPI_BEGIN
        };
    }

    var _sendHpi2DoctorSuccess = function(hpi){
        return {
            type: constants.SEND_HPI_SUCCESS
        };
    }

    var _sendHpi2DoctorFailure = function(){
        return {
            type: constants.SEND_HPI_FAILURE
        };
    }

    var _isSendingHpi = false;
    var _sendHpi2Doctor = function(accessToken){
        return function(dispatch, getState) {
            if(_isSendingHpi) return;

            var state = getState();
            var selectedProvider = state.specialist.mySpecialist;
            var selectedPractice = state.specialist.mySpecialistPractice;
            var subdomainPractice = state.practice.data;
            var subdomainProvider = state.practice.data.providers[0];
            var hpi = state.dashboard.latestHpi;

            // check to see if we need to send user selected practice
            // or if it should get the practice collected via subdomain
            // selected specialist/practice takes priority
            var practice = (Object.keys(selectedPractice).length !== 0) ? selectedPractice : subdomainPractice;
            var provider = (Object.keys(selectedProvider).length !== 0) ? selectedProvider : subdomainProvider;

            hpi._id = hpi.id;

            var observation = { provider: provider, practice: practice, hpi: hpi };
            
            _isSendingHpi = true;
            dispatch(_sendHpi2DoctorBegin());
            api.post('/proxy/v1/observations', observation, accessToken || state.auth.token)
                .then(function(res) {
                    _isSendingHpi = false;

                    dispatch(_sendHpi2DoctorSuccess(hpi));
                })
                .catch(function(error) {
                    _isSendingHpi = false;

                    dispatch(_sendHpi2DoctorFailure());

                    if(error.response){
                        dispatch(commonActions.setGenericResponseError('', error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        }
    }

    var _clearSendHpiStatus = function(){
        return {
            type: constants.CLEAR_SEND_HPI_STATUS
        };
    }

    return {
        fetchLatestHpi: _fetchLatestHpi,
        fetchLatestHpiIfNeeded: _fetchLatestHpiIfNeeded,
        sendHpi2Doctor: _sendHpi2Doctor,
        clearSendHpiStatus: _clearSendHpiStatus
    }
})();

module.exports = latestHpiActions;



// WEBPACK FOOTER //
// ./src/common/modules/dashboard/actions/latestHpi.js